export default "__VITE_ASSET__Di6cqpPE__"